import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ShareModal = ({ shareUrl, albumTitle, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  const handleShareNative = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: albumTitle,
          text: `View photos from ${albumTitle}`,
          url: shareUrl,
        });
      } catch (err) {
        console.error('Error sharing:', err);
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        className="bg-white rounded-lg max-w-md w-full p-8"
      >
        <h2 className="text-2xl font-light text-black mb-6">Share Album</h2>
        
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-3">
            Share this link with your guests:
          </label>
          <div className="flex border border-gray-300 rounded-md overflow-hidden">
            <input
              type="text"
              value={shareUrl}
              readOnly
              className="flex-1 px-4 py-3 bg-gray-50 text-sm font-mono text-gray-600 focus:outline-none"
            />
            <button
              onClick={handleCopyLink}
              className={`px-6 py-3 font-medium text-sm transition-colors ${
                copied
                  ? 'bg-green-600 text-white'
                  : 'bg-black text-white hover:bg-gray-800'
              }`}
            >
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>

        <div className="space-y-3 mb-8">
          {navigator.share && (
            <button
              onClick={handleShareNative}
              className="w-full px-4 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 font-medium transition-all btn-secondary"
            >
              Share via Device
            </button>
          )}
          
          <a
            href={`mailto:?subject=${encodeURIComponent(albumTitle)}&body=${encodeURIComponent(
              `View photos from ${albumTitle}: ${shareUrl}`
            )}`}
            className="block w-full px-4 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 font-medium text-center transition-all btn-secondary"
          >
            Share via Email
          </a>

          <a
            href={`sms:?body=${encodeURIComponent(
              `View photos from ${albumTitle}: ${shareUrl}`
            )}`}
            className="block w-full px-4 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 font-medium text-center transition-all btn-secondary"
          >
            Share via SMS
          </a>
        </div>

        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <h3 className="text-sm font-medium text-gray-900 mb-2">How it works:</h3>
          <ul className="text-sm text-gray-600 space-y-1 font-light">
            <li>• Anyone with this link can view and upload photos</li>
            <li>• No account required for guests to participate</li>
            <li>• Photos appear instantly in your album</li>
          </ul>
        </div>

        <button
          onClick={onClose}
          className="w-full px-4 py-3 bg-black text-white rounded-md hover:bg-gray-800 font-medium transition-all btn-primary"
        >
          Close
        </button>
      </motion.div>
    </div>
  );
};

export default ShareModal;